export const defaultCookieConsentName = "CookieConsent";
